import { SortConfig } from 'store/types/Table';
import { Attendee } from 'store/types/Meeting';
import { sorter } from 'util/table';

export enum AttendanceTableActionType {
  SetInitialList = 'SetInitialList',
  UpdateSort = 'UpdateSort',
}

export interface AttendanceTableState {
  initialList: Attendee[];
  list: Attendee[];
  sort: SortConfig<Attendee>;
}

export interface AttendanceTableAction {
  type: AttendanceTableActionType;
  payload: Partial<AttendanceTableState>;
}

const getSortedList = (list: Attendee[] = [], sort: SortConfig<Attendee>): Attendee[] =>
  list.length ? [...list].sort(sorter<Attendee>(sort)) : [...list];

export const initialState: AttendanceTableState = {
  initialList: [],
  list: [],
  sort: { column: 'company', direction: 'asc' },
};

const reducer = (state: AttendanceTableState, { type, payload }: AttendanceTableAction): AttendanceTableState => {
  if (type === AttendanceTableActionType.SetInitialList) {
    const { initialList = [] } = payload;
    const list = getSortedList(initialList ?? [], state.sort);

    return { ...state, initialList, list };
  }

  if (type === AttendanceTableActionType.UpdateSort) {
    const { sort = {} } = payload;

    return {
      ...state,
      sort,
      list: getSortedList(state.initialList, sort),
    };
  }

  return state;
};

export default reducer;
